import React, { useEffect, useState } from "react";
import Marquee from "react-fast-marquee";
import { fetchPartners } from "@/lib/api";
import { useI18n } from "@/lib/i18n";

export default function LogoReel({ compact = false }) {
  const { t } = useI18n();
  const [partners, setPartners] = useState([]);

  useEffect(() => {
    let alive = true;
    fetchPartners().then((d) => alive && setPartners(d.partners || [])).catch(() => {});
    return () => { alive = false; };
  }, []);

  if (!partners.length) return null;

  return (
    <section
      className={compact ? "" : "py-14 border-t"}
      style={{ borderColor: "var(--bp-border)" }}
      data-testid="partners-reel"
      aria-label={t.partners_title}
    >
      <div className={compact ? "" : "bp-container"}>
        <div
          className="uppercase text-xs tracking-widest mb-4"
          style={{ color: "var(--bp-text-muted)" }}
        >
          {t.partners_title}
        </div>
        <Marquee gradient={false} pauseOnHover speed={35} autoFill>
          {partners.map((p) => (
            <a
              key={p.id}
              href={p.link}
              target="_blank"
              rel="noopener noreferrer"
              className="mx-10 inline-flex items-center gap-3 opacity-60 hover:opacity-100 transition-opacity"
              data-testid={`partner-logo-${p.name.toLowerCase().replace(/\s+/g, "-")}`}
            >
              {p.logo_url ? (
                <img src={p.logo_url} alt={p.name} className="h-8 grayscale hover:grayscale-0 transition" />
              ) : (
                <span className="font-serif text-2xl tracking-tight" style={{ color: "var(--bp-text-secondary)" }}>
                  {p.name}
                </span>
              )}
            </a>
          ))}
        </Marquee>
      </div>
    </section>
  );
}
